<div class="pricing-popup-overlay" [class.active]="pricingPopupVisible">
    <div class="pricing-popup">
        <button class="pricing-popup-close"  (click)="closePricingPopup()">&times;</button>
        
        <div class="pricing-header">
            <h2>Choisissez votre formule</h2>
            <p>Toutes les offres incluent la plateforme de souscription et vos commissions</p>
        </div>

        <div class="pricing-bonus-banner">
            <h3>💰 Inclus dans toutes les offres</h3>
            <p>Générez <strong>1% de commission</strong> sur chaque produit souscrit (assurance-vie, SCPI, PER...)</p>
        </div>

        <div class="pricing-grid">
            <!-- Offre Gratuite - SILVER -->
            <div class="pricing-card tier-silver">
                <div class="pricing-card-header">
                    <div class="pricing-card-name">Essentiel</div>
                    <div class="pricing-card-subtitle">Pour tester</div>
                    <div class="pricing-card-price">
                        <span class="pricing-amount">Gratuit</span>
                    </div>
                </div>
                
                <ul class="pricing-features">
                    <li><strong>5 bilans/mois</strong></li>
                    <li>Export PDF avec logo Wealthlane</li>
                    <li>Plateforme de souscription <strong>illimitée</strong></li>
                    <li>Chat support</li>
                    <li class="highlight">+ 1% de commission par placement</li>
                </ul>

                <div class="pricing-cta">
                    <button class="btn-pricing">
                        Commencer gratuitement
                    </button>
                </div>
            </div>

            <!-- Offre Pro - GOLD -->
            <div class="pricing-card tier-gold">
                <div class="pricing-card-header">
                    <div class="pricing-card-name">Pro</div>
                    <div class="pricing-card-subtitle">Pour développer votre activité</div>
                    <div class="pricing-card-price">
                        <span class="pricing-amount">9,99€</span>
                        <span class="pricing-period">/mois</span>
                    </div>
                </div>
                
                <ul class="pricing-features">
                    <li><strong>Bilans illimités</strong></li>
                    <li><strong>Export 100% marque blanche</strong></li>
                    <li>Chat prioritaire (24h)</li>
                    <li>Webinar mensuel</li>
                    <li>Diplôme Wealthlane Academy <strong>-50%</strong> (125€)</li>
                    <li class="highlight">+ 1% de commission par placement</li>
                </ul>

                <div class="pricing-cta">
                    <button class="btn-pricing">
                        Choisir Pro
                    </button>
                </div>
            </div>

            <!-- Offre Premium - PLATINUM -->
            <div class="pricing-card tier-platinum">
                <div class="pricing-card-header">
                    <div class="pricing-card-name">Premium</div>
                    <div class="pricing-card-subtitle">Ingénierie patrimoniale incluse</div>
                    <div class="pricing-card-price">
                        <span class="pricing-amount">19,99€</span>
                        <span class="pricing-period">/mois</span>
                    </div>
                </div>
                
                <ul class="pricing-features">
                    <li><strong>Tout de l'offre Pro</strong></li>
                    <li><strong>Chat ingénierie dédiée</strong></li>
                    <li>Aide sur dossiers complexes</li>
                    <li>Tous les webinars + replays</li>
                    <li>Diplôme Wealthlane Academy <strong>OFFERT</strong> (250€)</li>
                    <li class="highlight">+ 1% de commission par placement</li>
                </ul>

                <div class="pricing-cta">
                    <button class="btn-pricing" >
                        Choisir Premium
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>